import { EventStatus } from "app/utils/const";
import { EventHelper } from "../../../../../../../helpers/eventHelper";
import type { EventType } from "../../../../../../../types/eventType";
import AsianOdds from "../../../../AsianOdds/AsianOdds";
import "./AsianEventMarketHandicap.scss";
type Props = {
  event: EventType;
  addBetSlip: (...args: Array<any>) => any;
  market: Record<string, any>;
};

const AsianEventMarketHandicap: React.FC<Props> = props => {
  const { market, addBetSlip, event } = props;
  const runners = market.runners;

  if (
    (market.status !== EventStatus.OPEN &&
      market.status !== EventStatus.SUSPENDED) ||
    !runners
  ) {
    return <div className="asian-market__no-runners"></div>;
  }

  let showTop;
  let formattedHandicap;
  runners.map((runner, index) => {
    if (runner.formattedHandicap) {
      showTop = index === 0 ? true : false;
      formattedHandicap = runner.formattedHandicap;
    }
  });
  return (
    <div className="asian-market__handicap">
      <div className="asian-market__handicap-value-container">
        {(showTop && formattedHandicap) || (
          <div className="handicap-value-spacer" />
        )}
        <span className="asian-market__handicap-value-container__handicap-value">
          {!showTop && formattedHandicap}
        </span>
      </div>

      <div className="asian-market__handicap-prices">
        {runners &&
          runners.map((runner, index) => {
            const highestOdds =
              runner &&
              runner["aggregatedPrices"] &&
              runner["aggregatedPrices"].length > 0 &&
              EventHelper.getHighestOddsValueFrom(runner["aggregatedPrices"]);
            return (
              <AsianOdds
                className={event["inRunning"] ? "asian-odds-live" : ""}
                odds={highestOdds}
                onClickPrice={() => addBetSlip(runner, props, event)}
                key={index}
                runner={runner}
                marketType={market.type}
              />
            );
          })}
      </div>
    </div>
  );
};

export default AsianEventMarketHandicap;
